import { useState } from 'react';
import isBoolean from 'lodash/isBoolean';
import { gql, useQuery } from '@apollo/client';

export const GET_CUSTOMERS = gql`
  query ($payload: GetCustomersInput!) {
    getCustomers(payload: $payload) {
      collection {
        _id
        name
        customerName
        companyName
        notes
        contactPersons {
          name
          email
          phoneNumber
        }
        email
        mobilePhoneNumber
        createdAt
        createdBy
        deleted
      }
      totalCount
    }
  }
`;

export const useGetAllCustomers = (companyId?: string, searchParam?: string) => {
  const [currentPage, setPage] = useState(1);
  const [currentNameSort, setNameSort] = useState<{ field: string; sortBy: number }[]>([]);
  const pageSize = 12;
  const { data } = useQuery(GET_CUSTOMERS, {
    variables: {
      payload: {
        companyId,
        deleted: false,
        queryOptions: {
          limit: pageSize,
          skip: pageSize * currentPage - pageSize,
          sort: currentNameSort,
        },
        searchParam: {
          searchParam,
        },
      },
    },
    skip: !companyId,
    fetchPolicy: 'network-only',
  });

  const getCustomers = data?.getCustomers || {};

  return {
    getCustomers: getCustomers?.collection || [],
    paginationConfig: {
      total: getCustomers?.totalCount || 0,
      pageSize,
      current: currentPage,
      onChange: (page: number) => setPage(page),
    },
    onTableChange: (a: any, b: any, sorter: any) => {
      if (sorter.order) {
        const sortBy = sorter.order === 'ascend' ? 1 : -1;

        setNameSort([{ field: sorter.field, sortBy }]);
      }
    },
  };
};

export const useGetCustomersWithoutPagination = ({
  companyId,
  searchParam,
  deleted,
}: {
  companyId?: string;
  searchParam?: string;
  deleted?: boolean;
}) => {
  const { data } = useQuery(GET_CUSTOMERS, {
    variables: {
      payload: {
        companyId,
        searchParam: { searchParam },
        ...(isBoolean(deleted) && { deleted }),
      },
    },
    skip: !companyId,
    fetchPolicy: 'network-only',
  });

  const customers = data?.getCustomers?.collection || [];

  return { customers };
};
